import { FC } from 'react'
import { Text } from '@blueprintjs/core'
import { GradientBorder } from 'client/components/GradientBorder/GradientBorder'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'
import { useTranslation } from 'react-i18next'
import { ClientLocaleNS } from 'lib/constants/locales'

type TProps = {}

const Categories: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.HomePage)
  return (
    <ResponsiveBlock className="my-16" contentClassName="justify-between flex-wrap gap-2">
      {Array(8)
        .fill(null)
        .map((_, index) => {
          const listNumber = index + 1
          return (
            <div key={listNumber} className="flex">
              <GradientBorder className="flex h-10 px-6 min-w-[128px] w-full">
                <Text tagName="span" className="whitespace-nowrap">
                  {t(`categories_block.list.${listNumber}.title`)}
                </Text>
              </GradientBorder>
            </div>
          )
        })}
    </ResponsiveBlock>
  )
}

export { Categories }
